<template>
  <div class="common_layout">
    <TopHeader title="商品管理" />

    <div
      class="center_flex_layout"
      style="justify-content: flex-end; margin-top: 14px"
    >
      <div
        v-for="(button, index) in detailButton.value"
        :key="index"
        :style="{
          marginLeft: index === 0 ? 0 : '9px',
          background: index === 0 ? '#ECF5FF' : '#409EFF',
          color: index === 0 ? '#409EFF' : '#FFFFFF',
        }"
        @click="topButtonAction(button)"
        class="top_detail_button"
      >
        {{ button.name }}
      </div>
    </div>

    <div
      v-for="(goods, index) in goodsListData.value"
      :key="index"
      class="goods_list_item"
      :style="{ marginTop: index === 0 ? '13px' : '20px' }"
    >
      <div
        class="center_flex_layout"
        style="justify-content: flex-start; align-items: flex-start"
      >
        <el-image class="goods_image" :src="goods.imgUrl" lazy />

        <div style="margin-left: 10px; width: calc(100% - 105px)">
          <p class="common_font goods_name_hidden">{{ goods.goodsTitle }}</p>

          <p
            class="common_font"
            style="color: #409eff; margin-top: 4px; font-weight: bolder"
          >
            CNY {{ goods.goodsPrice }}
          </p>
        </div>
      </div>

      <div class="center_flex_layout" style="justify-content: flex-end">
        <div class="delete_button" @click="deleteAlertPop(goods)">刪除</div>

        <div
          class="delete_button"
          style="width: 80px; margin-left: 10px; background: #409eff"
          @click="viewGoodsDetail(goods)"
        >
          查看詳情
        </div>
      </div>
    </div>

      <!--包裝袋詳情-->
      <van-popup
              v-model:show="showPop"
              style="border-radius: 4px; width: 90%; padding: 16px;"
              closeable
              :close-on-click-overlay="false"
      >

          <p class="common_font" style="font-size: 18px; font-weight: bolder;">提示</p>

          <p class="common_font" style="margin-top: 21px;">包裝袋主圖</p>

          <div class="center_flex_layout" style="justify-content: flex-start;">

              <el-upload
                      v-model:file-list="fileList"
                      action="https://test.sancttech.com:8075/file/upload"
                      :headers="uploadImgHead.value"
                      list-type="picture-card"
                      :show-file-list="false"
                      :on-preview="handlePictureCardPreview"
                      :on-remove="handleRemove"
                      :on-success="uploadSuccess"
                      :limit="1"
                      name="multipartFile"
                      :on-exceed="handleExceed"
                      :before-upload="uploadBefore"
              >
                  <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                  <el-icon v-else><Plus /></el-icon>
              </el-upload>

              <el-button v-if="imageUrl" style="margin-left: 10px;" type="danger" icon="Delete" @click="deleteMainImg" circle />

          </div>

          <p class="common_font" style="margin-top: 25px;">包裝袋標題</p>

          <el-input size="large" class="common_font" style="margin-top: 5px;" v-model="packageTitle.value" placeholder="請輸入包裝袋標題"/>

          <p class="common_font" style="margin-top: 45px;">包裝袋價格</p>

          <div class="center_flex_layout" style="justify-content: flex-start;">

              <p class="common_font" style="margin-right: 10px;">CNY</p>

              <el-input type="number" size="large" class="common_font" style="margin-top: 5px;" v-model="packagePrice.value" placeholder="請輸入價格"/>

          </div>

          <div class="center_flex_layout" style="justify-content: flex-end; margin-top: 38px;">
              <el-row>
                  <el-button size="large" @click="onClickOverlay">取消</el-button>
                  <el-button type="primary" size="large" @click="confirmAdd">確定</el-button>
              </el-row>
          </div>

      </van-popup>
  </div>
</template>

<script setup>

    import {reactive, ref, onMounted, getCurrentInstance} from 'vue';
    import { get,post } from '../../utils/request';
    import { Encrypt } from '../../utils/secret'
    import { ElLoading } from 'element-plus';
    import { useRouter } from "vue-router";
    const router = useRouter();
    const {proxy} = getCurrentInstance();

    const detailButton = reactive({value: [
            {name: '包裝袋詳情', type: 'package'},
            {name: '添加', type: 'add'},
        ]});
    const goodsListData = reactive({value: []});
    const showPop = ref(false);
    const packageId = reactive({value: ''});
    const packageTitle = reactive({value: ''});
    const packagePrice = reactive({value: ''});
    const fileList = ref([]);
    const imageUrl = ref('');
    const upload = ref('');
    const uploadImgHead = reactive({value: ''});
    let loading;

    onMounted(() => {
        uploadImgHead.value = {
            'Authorization': 'Bearer ' + localStorage.access_token,
        };
        getGoodsList();
    });

    const getGoodsList = () => {
        get("/manager/goods/list?page=1&size=10000", {})
            .then((res) => {
                // console.log(JSON.stringify(res));
                if (res.code === 1) {
                    goodsListData.value = res.result.list;
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const topButtonAction =(button)=> {
        // console.log(button);
        if (button.type === 'add') {
            router.push('/addEditGoods?goodsId=');
        } else {
            getBagDetail();
            showPop.value = true;
            packageTitle.value = '';
            packagePrice.value = '';
            fileList.value = [];
            imageUrl.value = '';
        }
    };

    const deleteAlertPop =(data)=> {

        proxy.$showDialog({
            title: '提示',
            message: '是否刪除【'+data.goodsTitle+'】？刪除後將無法恢復',
        })
            .then(() => {
                // on confirm
                deleteGoodsData(data);
            })
            .catch(() => {
                // on cancel
            });

    };

    const deleteGoodsData =(data)=> {

        post('/manager/goods/delete?goodsId='+data.id, {}, null)
            .then(res => {
                // console.log(JSON.stringify(res));
                if(res.code === 1){
                    proxy.$toast('刪除成功');
                    getGoodsList();
                }
            })
            .catch(error => {
                console.log(error);
            })

    };

    const viewGoodsDetail =(data)=> {
        let goodsNum = encodeURIComponent(Encrypt(JSON.stringify(data.id)));
        router.push('/addEditGoods?goodsId='+goodsNum);
    };

    // 獲取包裝袋詳情
    const getBagDetail =()=> {

        get('/manager/goods/bag', {})
            .then(res => {
                // console.log(JSON.stringify(res));
                if(res.code === 1){
                    packageId.value = res.result.id;
                    packageTitle.value = res.result.goodsTitle;
                    packagePrice.value = res.result.goodsPrice;
                    imageUrl.value = res.result.imgUrl;
                }
            })
            .catch(error => {
                console.log(error);
            })

    };

    const handleRemove =(uploadFile, uploadFiles)=> {
        // console.log(uploadFile, uploadFiles);
    };

    const handlePictureCardPreview =(uploadFile)=> {
        // console.log(uploadFile);
    };

    const handleExceed =(files)=> {
        // upload.value.clearFiles();
        // const file = files[0] as UploadRawFile;
        // file.uid = genFileId();
        // upload.value.handleStart(file);
    };

    const uploadBefore =()=> {
        loading = ElLoading.service({
            lock: true,
            text: 'Loading',
            background: 'rgba(0, 0, 0, 0.7)',
        })
    };

    const uploadSuccess =(file)=> {
        // console.log(JSON.stringify(file));
        imageUrl.value = file.result.url;
        setTimeout(() => {
            loading.close();
        }, 500)
    };

    const onClickOverlay =()=> {
        showPop.value = false;
    };

    const deleteMainImg =()=> {
        fileList.value = [];
        imageUrl.value = '';
    };

    const confirmAdd =()=> {

        if (!imageUrl.value) {
            proxy.$toast('請上傳包裝袋主圖');
            return;
        }

        if (!packageTitle.value) {
            proxy.$toast('請輸入包裝袋標題');
            return;
        }

        if (!packagePrice.value) {
            proxy.$toast('請輸入價格');
            return;
        }

        let addGoodsParams = {
            id: packageId.value,
            type: 2,
            goodsTitle: packageTitle.value,
            imgUrl: imageUrl.value,
            goodsPrice: packagePrice.value,
        };

        // console.log(addGoodsParams);

        post('/manager/goods/handle', addGoodsParams, null)
            .then(res => {
                // console.log(JSON.stringify(res));
                if(res.code === 1){
                    showPop.value = false;
                    proxy.$toast('保存成功');
                }
            })
            .catch(error => {
                console.log(error);
            })

    };

</script>

<style lang="less" scoped>
.top_detail_button {
  width: 126px;
  padding: 5px 0;
  border-radius: 2px;
  border: 1px #409eff solid;
  background: #409eff;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
}

.goods_list_item {
  padding: 16px 0;
  padding-left: 4px;
  padding-right: 20px;
  margin-top: 20px;
  border-radius: 4px;
  border: 1px #dcdfe6 solid;
}

.goods_image {
  width: 71px;
  height: 71px;
}

.goods_name_hidden {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}

.delete_button {
  width: 60px;
  padding: 5px 0;
  border-radius: 2px;
  background: #f56c6c;
  font-size: 14px;
  color: #ffffff;
  text-align: center;

  &:active {
    opacity: 0.8;
  }
}
</style>
